import { AlpineComponent } from "@nxtlvlsoftware/alpine-typescript/";
import { NotificationData, NotificationInstance } from "./notifier.component.types";

export class NotifierComponent extends AlpineComponent {
    public Notifications: NotificationInstance[] = [];

    public add(event: CustomEvent<NotificationData>) {
        this.Notifications.push({
            id: event.timeStamp,
            type: event.detail.type,
            message: event.detail.message });
    }
    public remove(instance: NotificationInstance) {
        this.Notifications = this.Notifications.filter(notification => instance.id !== notification.id);
    }
}